// Соотношение сторон с бэка приходит строкой: «280 / 280», «3/4», «1107 / 623».
// Раньше строка выполнялась через eval — код с бэка в рантайме и падение
// всей карточки на мусоре вроде «0 / 0». Здесь — обычный разбор.

// Ширина / высота или null, если строка не похожа на соотношение.
export function parseRatio(value?: string | null): number | null {
  if (!value) {
    return null
  }
  const parts = value.split('/').map((part) => Number(part.trim()))
  if (parts.length !== 2) {
    return null
  }
  const [width, height] = parts
  return width > 0 && height > 0 ? width / height : null
}

// padding-top для «распорки» под картинку: высота в процентах от ширины.
export function paddingTopFromRatio(value?: string | null): string | undefined {
  const ratio = parseRatio(value)
  return ratio ? `${100 / ratio}%` : undefined
}
